<template>
<div v-loading="isSuccess" class="CourseDetails" id="coursedetailswarp">
    <div class="course_top_warp">
        <div class="course_info_warp">
            <div>
                <p @click="toIndex" class="jump_text">首页</p>
                <span>></span>
                <p @click="pageJump(courseDetailsData.firstcode, courseDetailsData.firstcodename)" v-if="courseDetailsData.firstcodename !== ''" class="jump_text">{{courseDetailsData.firstcodename}}</p>
                <span v-if="courseDetailsData.firstcodename !== ''">></span>
                <p @click="pageJump(courseDetailsData.secondcode, courseDetailsData.secondcodename)" v-if="courseDetailsData.secondcodename !== ''" class="jump_text">{{courseDetailsData.secondcodename}}</p>
                <span v-if="courseDetailsData.secondcodename !== ''">></span>
                <p>{{courseDetailsData.subject}}</p>
            </div>
            <div>
                <div class="left_box">
                    <img v-lazy="courseDetailsData.coverurl" alt="">
                </div>
                <div class="right_box">
                    <div>
                        <p class="p_title">{{courseDetailsData.subject}}</p>
                        <p class="p_desc" v-if="courseDetailsData.description">{{courseDetailsData.description}}</p>
                        <!-- <p class="p_eva">
                            <span>评价指数 </span>
                            <span v-if="courseDetailsData.evaluatecount === 0">当前课程暂无评分</span>
                            <el-rate v-if="courseDetailsData.evaluatecount > 0" v-model="courseDetailsData.evaluatecount" disabled></el-rate>
                        </p> -->
                        <div class="memberTips" @click="handleGoMemberDetails">
                            <div class="iconTips">
                                <img :src="require('@/common/images/course/member_icon.png')" class="memberIcon" alt="">
                                <div class="tips">加入蓝鲸会员享受更多权益！</div>
                            </div>
                            <img :src="require('@/common/images/course/arrow_icon.png')" class="arrowIcon" alt="">
                        </div>
                        <div class="coupon" v-if="courseDetailsData.couponvoucherlist && courseDetailsData.couponvoucherlist.length">
                            <div class="name">优惠券</div>
                            <div class="list">
                                <div class="getLabel">领券</div>
                                <div class="item" @click="getCoupon(item, index)" v-show="item.inventory" v-for="(item, index) in courseDetailsData.couponvoucherlist" :key="index">
                                    {{item.prefercontent}}
                                </div>
                            </div>
                        </div>
                        <div v-if="!courseDetailsData.islimitcount || (courseDetailsData.islimitcount && courseDetailsData.zjmemtype && courseDetailsData.plusprice < courseDetailsData.saleprice)">
                            <div class="p_price">
                                <label v-if="courseDetailsData.feetype === 1">免费</label>
                                <span v-if="courseDetailsData.feetype === 2 && (!courseDetailsData.zjmemtype || (courseDetailsData.zjmemtype === 2 && courseDetailsData.plusprice == 0))">¥{{courseDetailsData.saleprice}}</span>
                                <span v-if="courseDetailsData.feetype === 2 && courseDetailsData.uprice !== '0.00' && (!courseDetailsData.zjmemtype || (courseDetailsData.zjmemtype === 2 && courseDetailsData.plusprice == 0))">¥{{courseDetailsData.uprice}}</span>
                                <div class="div_price" v-if="courseDetailsData.feetype === 2 && courseDetailsData.zjmemtype && !user.zjmemtype && courseDetailsData.plusprice > 0">
                                    <div class="saleprice">¥{{courseDetailsData.saleprice}}</div>
                                    <img :src="require('@/common/images/course/plus_price_icon1.png')" class="plusPriceIcon1" alt="">
                                    <span class="plusPrice">￥{{ courseDetailsData.plusprice }}</span>
                                </div>
                                <div class="div_price" v-if="courseDetailsData.feetype === 2 && courseDetailsData.zjmemtype && user.zjmemtype && courseDetailsData.plusprice > 0">
                                    <div class="saleprice">¥{{courseDetailsData.plusprice}}</div>
                                    <img :src="require('@/common/images/course/plus_price_icon2.png')" class="plusPriceIcon2" alt="">
                                    <span class="plusPrice">原价：￥{{ courseDetailsData.saleprice }}</span>
                                </div>
                            </div>
                            <el-button @click="joinCourse" v-if="courseDetailsData.feetype === 1 && courseDetailsData.isjoin === 0" type="danger" round>立即参加</el-button>
                            <el-button @click="handleGoMemberDetails(1)" v-if="courseDetailsData.feetype === 2 && courseDetailsData.isjoin === 0 && courseDetailsData.zjmemtype && !user.zjmemtype && courseDetailsData.plusprice > 0" type="openPlus" round>开通PLUS会员</el-button>
                            <el-button @click="handleGoMemberDetails(2)" v-if="courseDetailsData.feetype === 2 && courseDetailsData.isjoin === 0 && courseDetailsData.zjmemtype && user.zjmemtype === 1 && courseDetailsData.plusprice > 0" type="upgrade" round>升级蓝鲸年卡</el-button>
                            <el-button @click="handleGoMemberDetails(2)" v-if="courseDetailsData.feetype === 2 && courseDetailsData.isjoin === 0 && courseDetailsData.zjmemtype === 2 && courseDetailsData.plusprice == 0" type="upgrade" round>开通蓝鲸年卡</el-button>
                            <el-button @click="buyNow" v-if="courseDetailsData.feetype === 2 && courseDetailsData.isjoin === 0 && courseDetailsData.zjmemtype && user.zjmemtype !== 2" type="danger" round>直接购买</el-button>
                            <el-button @click="buyNow" v-else-if="courseDetailsData.feetype === 2 && courseDetailsData.isjoin === 0 && (!courseDetailsData.zjmemtype || (courseDetailsData.zjmemtype === 1 && user.zjmemtype === 1) || (courseDetailsData.zjmemtype === 1 && user.zjmemtype === 2))" type="danger" round>立即购买</el-button>
                            <el-button @click="soonLearn" v-if="courseDetailsData.isjoin === 1" type="danger" round>马上学习</el-button>
                        </div>
                        <div v-else class="limit-time">
                            <div class="limit-time-header">
                                <div class="left">
                                    <i class="icon icon-course-time"></i>
                                    <span>{{courseDetailsData.tagname?courseDetailsData.tagname:'限时秒杀价'}}</span>
                                </div>
                                <div class="right">
                                    <span class="sepa-r" v-if="timer.day">{{timer.day}}天</span>
                                    <span class="time-box sepa-l sepa-r">{{timer.hour}}</span>:
                                    <span class="time-box sepa-l sepa-r">{{timer.minute}}</span>:
                                    <span class="time-box sepa-l">{{timer.second}}</span>
                                </div>
                            </div>
                            <div class="bg-limit-time">
                                <div class="limit-time-body">
                                    <span class="label">秒杀价</span>
                                    <span class="saleprice">¥{{courseDetailsData.saleprice}}</span>
                                    <span class="uprice">¥{{courseDetailsData.uprice}}</span>
                                </div>
                                <div class="limit-time-footer">
                                    <el-button @click="buyNow" v-if="courseDetailsData.feetype === 2 && courseDetailsData.isjoin === 0" type="danger" round>立即购买</el-button>
                                    <el-button @click="soonLearn" v-if="courseDetailsData.isjoin === 1" type="danger" round>马上学习</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right_bottom_box">
                        <!-- <span>已有{{courseDetailsData.joincount}}人参与</span>
                        <span>｜</span> -->
                        <span v-if="courseDetailsData.goodcommentrate>0">好评度 {{courseDetailsData.goodcommentrate}}%</span>
                        <span v-if="courseDetailsData.goodcommentrate>0">｜</span>
                        <el-popover
                            placement="top"
                            width="106"
                            trigger="hover">
                            <div class="icon_popover_box">
                                <!-- <img style="width: 100px; height: 100px;" v-lazy="require('@/common/images/header/gz_code.png')" alt=""> -->
                                <div id="qrcode"></div>
                                <p>扫码手机分享</p>
                            </div>
                            <span class="icon_box cursor_class" slot="reference">
                                <img :src="require('@/common/images/other/share_icon.png')" alt="">
                                <span>分享</span>
                            </span>
                        </el-popover>
                        <span>｜</span>
                        <el-popover
                            placement="top"
                            width="106"
                            trigger="hover">
                            <div class="icon_popover_box">
                                <!-- <img style="width: 100px; height: 100px;" v-lazy="require('@/common/images/header/gz_code.png')" alt=""> -->
                                <div id="qrcode2"></div>
                                <p>扫码手机学习</p>
                            </div>
                            <span class="icon_box cursor_class" slot="reference">
                                <img :src="require('@/common/images/other/phone_icon.png')" alt="">
                                <span>手机学习</span>
                            </span>
                        </el-popover>
                        <span>｜</span>
                        <span @click="enshrineClick(courseDetailsData.isfavorite)" :class="courseDetailsData.isfavorite === 1 ? 'is_enshrine':''" class="cursor_class enshrine"><img :src="courseDetailsData.isfavorite === 1 ? require('@/common/images/other/y_enshrine.png') : require('@/common/images/other/n_enshrine.png')" alt="">{{courseDetailsData.isfavorite === 0 ? '添加' : '取消'}}收藏</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-show="!isSuccess" class="course_content_warp">
        <div class="container_box">
            <div class="course_details_info_box">
                <div class="course_details_info_left">
                    <div class="content_box">
                        <div class="course_tabs_box">
                            <div @click="menuClick(1)" :class="menuIndex === 1 ? 'active' : ''">课程介绍</div>
                            <div v-if="courseDetailsData.coursetype === 2" @click="menuClick(2)" :class="menuIndex === 2 ? 'active' : ''">章节目录<label v-if="courseDetailsData.isstry === 1">试看</label></div>
                            <!-- <div @click="menuClick(3)" :class="menuIndex === 3 ? 'active' : ''">用户评价<span v-if="courseDetailsData.commentcount-1 > 0">{{courseDetailsData.commentcount-1}}</span></div> -->
                            <div @click="menuClick(6)" :class="menuIndex === 6 ? 'active' : ''" v-if="courseDetailsData.relqblist && courseDetailsData.relqblist.length">课程题库</div>
                            <div @click="menuClick(4)" :class="menuIndex === 4 ? 'active' : ''">课程笔记<span v-if="courseDetailsData.notescount > 0">{{courseDetailsData.notescount}}</span></div>
                            <div @click="menuClick(5)" v-if="courseDetailsData.ishavedoc" :class="{'active': menuIndex === 5 ? true : false, 'menuIndex5':true}">资料<span v-if="material.length > 0">{{material.length}}</span></div>
                        </div>
                        <div v-show="menuIndex === 1" class="course_tabs_item_box introduce_warp">
                            <div v-if="courseDetailsData.content === ''" class="no_data_box">
                                <img :src="require('@/common/images/other/no_data.png')" alt="">
                                <span>当前课程暂无介绍</span>
                            </div>
                            <div v-else class="introduce_box" v-html="courseDetailsData.content"></div>
                        </div>
                        <div v-show="menuIndex === 2" class="course_tabs_item_box cata_warp">
                            <div v-if="chapterData.length === 0" class="no_data_box">
                                <img :src="require('@/common/images/other/no_data.png')" alt="">
                                <span>当前课程暂无目录</span>
                            </div>
                            <div v-if="chapterData.length > 0" class="cata_box">
                                <div class="cata_item_box" v-for="(item, index) in chapterData" :key="index">
                                    <!-- {{item.sectionindexname}}&emsp; -->
                                    <p class="cata_title_text"><span>{{item.sectionname}}</span><span v-if="courseDetailsData.sectionunlocktype === 2">{{item.datetime}}</span></p>
                                    <div v-if="item.taskinfolist.length === 0" class="no_task_box">暂无章节任务</div>
                                    <div @click="taskClick(item, subItem)" class="section_box" v-for="(subItem, subIndex) in item.taskinfolist" :key="subIndex">
                                        <div>
                                            <!-- <p>{{subItem.taskindexname}}</p> -->
                                            <p></p>
                                            <p>{{subItem.taskname}}</p>
                                        </div>
                                        <div>
                                            <div class="isTry" v-if="subItem.istry === '1'">试看内容</div>
                                            <div class="no_hover_box">
                                                <img v-if="subItem.kmctype === '2'" :src="require('@/common/images/other/img_icon.png')" alt="">
                                                <img v-if="subItem.kmctype === '6'" :src="require('@/common/images/other/audio_icon.png')" alt="">
                                                <img v-if="subItem.kmctype === '4'" :src="require('@/common/images/other/video_icon.png')" alt="">
                                                <p>{{subItem.timelength | ChangeHourMinutestr}}</p>
                                            </div>
                                            <div class="hover_box">
                                                <div v-if="((courseDetailsData.feetype === 1 && subItem.isunlock === 1) || (courseDetailsData.isjoin === 1 && subItem.isunlock === 1)) && courseDetailsData.isjoin === 1"><img :src="require('@/common/images/other/see_icon.png')" alt="">开始学习</div>
                                                <!-- <div v-if="subItem.isunlock === 0 && courseDetailsData.isjoin === 1"><img :src="require('@/common/images/other/lock_icon.png')" alt="">待解锁学习</div> -->
                                                <div v-else-if="(courseDetailsData.feetype === 1 && subItem.isunlock === 0 && subItem.istry === '0') || (courseDetailsData.isjoin === 1 && subItem.isunlock === 0 && subItem.istry === '0')"><img :src="require('@/common/images/other/lock_icon.png')" alt="">待解锁学习</div>
                                                <div v-else-if="courseDetailsData.feetype === 2 && courseDetailsData.isjoin === 0 && subItem.istry === '0'">需购买后观看</div>
                                                <!-- <div v-if="subItem.istry === '1' && subItem.isunlock === 0 && courseDetailsData.feetype === 2"><img :src="require('@/common/images/other/see_icon.png')" alt="">课时预览</div> -->
                                                <div v-else-if="(courseDetailsData.isjoin === 0 && subItem.isunlock === 1) || ((courseDetailsData.feetype === 1 && subItem.isunlock === 0 && subItem.istry === '1') || (courseDetailsData.isjoin === 1 && subItem.isunlock === 0 && subItem.istry === '1')) || (subItem.istry === '1' && subItem.isunlock === 0 && courseDetailsData.feetype === 2) || (courseDetailsData.isjoin === 0 && subItem.istry === '1')"><img :src="require('@/common/images/other/see_icon.png')" alt="">课时预览</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div v-show="menuIndex === 3" class="course_tabs_item_box evaluate_warp">
                            <div v-if="courseDetailsData.isjoin === 1 && courseDetailsData.iscommen === 0" class="evaluate_btn_box">
                                <p>快来为本课程打个分吧，并说说你对该课程的想法。</p>
                                <el-button @click="openEvaPop" type="primary" size="mini">课程评价</el-button>
                            </div>
                            <div v-show="courseCommentData.length === 0 && evaRadioValue === 0" class="no_data_box">
                                <img :src="require('@/common/images/other/no_data.png')" alt="">
                                <span>当前课程暂无评价</span>
                            </div>
                            <div v-show="courseCommentData.length > 0 || evaRadioValue !== 0" class="evaluate_box">
                                <div class="evaluate_filtrate_box" :class="!(courseDetailsData.isjoin === 1 && courseDetailsData.iscommen === 0) ? 'margin_top0' : ''">
                                    <div>
                                        <p>{{courseDetailsData.goodcommentrate}}%</p>
                                        <p>好评度</p>
                                    </div>
                                    <div>
                                        <el-radio-group @change="evaFilHandle" v-model="evaRadioValue">
                                            <el-radio :label="0">全部（{{courseDetailsData.commentcount-1}}）</el-radio>
                                            <el-radio :label="1">好评（{{courseDetailsData.goodcomment-1}}）</el-radio>
                                            <el-radio :label="2">中评（{{courseDetailsData.mediumcomment}}）</el-radio>
                                            <el-radio :label="3">差评（{{courseDetailsData.badcomment}}）</el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <div class="evaluate_item_warp">
                                    <div class="evaluate_item_box" v-for="(item, index) in courseCommentData" :key="index">
                                        <img :src="item.customeratturl === '' || item.customeratturl === ' ' || !item.customeratturl ? require('@/common/images/header/user.png') : item.customeratturl" alt="">
                                        <div>
                                            <div class="name_div">
                                                <span>{{item.customername}}</span>
                                                <el-rate :allow-half="true" disabled v-model="item.evaluatecount"></el-rate>
                                            </div>
                                            <p class="details_text">{{item.content}}</p>
                                            <p class="date_text">{{item.datetime}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="courseCommentData.length > 0 || evaRadioValue !== 0" class="page_box evaluate_page_box">
                                <el-pagination background layout="prev, pager, next" :page-size="6" :total="commentPageTotal"  @current-change="pfPage"></el-pagination>
                            </div>
                        </div> -->
                        <div v-show="menuIndex === 4" class="course_tabs_item_box notes_warp">
                            <div v-if="courseNotesData.length === 0" class="no_data_box">
                                <img :src="require('@/common/images/other/no_data.png')" alt="">
                                <span>当前课程暂无笔记</span>
                            </div>
                            <div v-if="courseNotesData.length > 0" class="notes_box">
                                <div class="notes_item_box" v-for="(item, index) in courseNotesData" :key="index">
                                    <!-- <img :src="item.customeratturl" alt=""> -->
                                    <img :src="item.customeratturl === '' || item.customeratturl === ' ' || !item.customeratturl ? require('@/common/images/header/user.png') : item.customeratturl" alt="">
                                    <div>
                                        <p class="name_text">{{item.customername}}</p>
                                        <p class="details_text">{{item.content}}</p>
                                        <div>
                                            <p>{{item.datetime}}</p>
                                            <!-- <p>
                                                <img :src="require('@/common/images/other/like.png')" alt="">
                                                <img :src="require('@/common/images/other/like2.png')" alt="">
                                                赞（{{item.praisecount}}）
                                            </p> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="page_box" style="margin-top: 12px;"> -->
                            <div v-if="courseNotesData.length > 0" class="page_box notes_page_box">
                                <el-pagination background layout="prev, pager, next" :page-size="6" :total="notesPageTotal"  @current-change="nfPage"></el-pagination>
                            </div>

                        </div>
                        <div v-show="menuIndex === 5" class="course_tabs_item_box data_warp">
                            <div class="material_item" v-for="(item, index) in material" :key="index">
                                <div class="material_item_name">{{item.docname}}</div>
                                <div class="material_item_btn" v-if="courseDetailsData.isjoin">
                                    <div class="box" @click="download(item)">
                                        <img :src="require('@/common/images/other/download.png')" alt="">
                                        <span>下载资料</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="menuIndex === 6" class="course_tabs_item_box ques_warp">
                            <div class="quesItem" @click="handleGoQbDetails(item)" v-for="(item, index) in courseDetailsData.relqblist" :key="index">
                                <div class="quesName">{{ item.subject }}</div>
                                <div class="rightHandle">
                                    <div class="isJoin" v-if="courseDetailsData.isjoin">
                                        <img :src="require('@/common/images/course/handle_icon.png')" class="icon" alt="">
                                        立即做题
                                    </div>
                                    <div class="noJoin" v-else>{{courseDetailsData.feetype === 2 ? '购买' : '参加'}}课程免费做题</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="course_details_info_right">
                    <div class="organ_info_box1">
                        <div class="box1">
                            <!-- <img :src="require('@/common/images/header/test.jpg')" alt=""> -->
                            <img @click="toOrganPage(courseDetailsData.hostinfo.hostid)" v-lazy="courseDetailsData.hostinfo.hostlogourl" alt="">
                            <div>
                                <p @click="toOrganPage(courseDetailsData.hostinfo.hostid)">{{courseDetailsData.hostinfo.hostname}}</p>
                                <img v-lazy="require('@/common/images/organ/grrz.png')" alt="">
                            </div>
                        </div>
                        <!-- <div class="box2">
                            <div @click="toOrganPage(courseDetailsData.hostinfo.hostid, '课程')">
                                <p>课程数</p>
                                <span>{{courseDetailsData.hostinfo.coursecount}}</span>
                            </div>
                            <label></label>
                            <div @click="toOrganPage(courseDetailsData.hostinfo.hostid)">
                                <p>学生数</p>
                                <span>{{courseDetailsData.hostinfo.studentcount}}</span>
                            </div>
                            <label></label>
                            <div @click="toOrganPage(courseDetailsData.hostinfo.hostid)">
                                <p>好评度</p>
                                <span>{{courseDetailsData.hostinfo.feedback}}%</span>
                            </div>
                        </div> -->
                        <div class="box3">{{courseDetailsData.hostinfo.description}}</div>
                    </div>
                    <div @click="showServiceQrImg = true" v-if="courseDetailsData.hostinfo.serviceqrurl !== ''" class="organ_info_box2">
                        <img v-lazy="courseDetailsData.hostinfo.serviceqrurl" alt="">
                        <!-- <img :src="require('@/common/images/header/test.jpg')" alt=""> -->
                        <div>
                            <p>{{courseDetailsData.hostinfo.hostname}}</p>
                            <p>关注微信客服了解最新课程</p>
                        </div>
                    </div>
                    <div class="organ_info_box3">
                        <p class="tdkc">TA的课程</p>
                        <div v-if="courseDetailsData.hostinfo.hostcourselist.length > 0">
                            <div @click="courseClick(item.courseid)" class="kc_box" v-for="(item, index) in courseDetailsData.hostinfo.hostcourselist" :key="index">
                                <img v-lazy="item.coverurl" :alt="item.subject">
                                <p>{{item.subject}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p class="recommend_title_text">还为您推荐以下课程</p>
            <div v-if="recommendCourse.length > 0" class="recommend_course_box">
                <div @click="courseClick(item.courseid)" class="course_item_div" v-for="(item, index) in recommendCourse" :key="index">
                    <img v-lazy="item.coverurl" :alt="item.subject">
                    <div>
                        <p>{{item.subject}}</p>
                        <p><span>{{item.feetype === 1 ? '免费' : `￥${item.saleprice}`}}</span>{{item.joincount}}人参与</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <transition name = "fade">
        <div v-if="joinStudyPop" class="join_study_pop">
            <div class="join_study_box">
                <img @click="closeJoinStudyPop()" class="close_icon" :src="require('@/common/images/header/close.png')" alt="">
                <img :src="require('@/common/images/other/other.png')" alt="">
                <p>恭喜你已成功加入学习！</p>
                <el-button @click="soonLearn" type="danger" round size="mini">马上学习</el-button>
            </div>
        </div>
        <div v-if="evaCoursePop" class="eva_course_pop">
            <div class="eva_course_box">
                <img @click="evaCoursePop = false" class="close_icon" :src="require('@/common/images/header/close.png')" alt="">
                <p>快为本门课程打个分吧！</p>
                <p>评价指数：<el-rate :allow-half="true" v-model="courseEvaValue"></el-rate></p>
                <el-input maxlength="90" show-word-limit type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"></el-input>
                <div>
                    <el-button @click="evaBtn" type="primary" size="mini">立即评价</el-button>
                </div>
            </div>
        </div>
        <div v-if="showServiceQrImg" class="qr_img_pop">
            <div>
                <img @click="showServiceQrImg = false" class="close_icon" :src="require('@/common/images/header/close.png')" alt="">
                <img v-lazy="courseDetailsData.hostinfo.serviceqrurl" alt="">
            </div>
        </div>
    </transition>
    <!-- <dialog  ref="dialog" :courseDetailsData="courseDetailsData" /> -->
    <el-dialog title="" :visible.sync="dialogVisible" width="375px" class="dialog">
        <div class="content">
            <img :src="require('@/common/images/other/tips.png')" alt="">
            <p><span v-if="courseDetailsData.feetype === 1">参与</span><span v-if="courseDetailsData.feetype === 2">购买</span>后课程有效期为{{courseDetailsData.expiredays}}天，确认继续<span v-if="courseDetailsData.feetype === 1">参与</span><span v-if="courseDetailsData.feetype === 2">购买</span>吗？</p>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button class="cancel" @click="dialogVisible = false"><span v-if="courseDetailsData.feetype === 1">暂不参与</span><span v-if="courseDetailsData.feetype === 2">暂不购买</span></el-button>
            <el-button class="affirm" type="primary" @click="affirmJoin"><span v-if="courseDetailsData.feetype === 1">确定参与</span><span v-if="courseDetailsData.feetype === 2">确定购买</span></el-button>
        </div>
    </el-dialog>
    <el-dialog :visible.sync="getCouponDialog" :close-on-click-modal="false" :close-on-press-escape="false" width="456px" class="getCouponDialog">
        <div class="getCouponDialogContent">
            <img :src="require('@/common/images/course/success.png')" class="success" alt="">
            <p class="success_tips">优惠券领取成功</p>
            <p class="tips">个人中心可查看我的优惠券</p>
            <el-button @click="getCouponDialog = false">好的</el-button>
        </div>
    </el-dialog>
    <el-dialog :visible.sync="getCouponFailDialog" :close-on-click-modal="false" :close-on-press-escape="false" width="290px" class="getCouponFailDialog">
        <div class="getCouponFailDialogContent">
            <p class="fail_tips">抱歉，当前优惠券限领{{astrictcount}}张！</p>
            <p class="tips">个人中心可查看我的优惠券</p>
            <el-button @click="getCouponFailDialog = false">好的</el-button>
        </div>
    </el-dialog>
    <el-dialog :visible.sync="showCommonForm" :close-on-click-modal="false" :close-on-press-escape="false" width="240px" class="commonform">
        <div class="container">
            <img class="img" v-lazy="courseDetailsData.naireUrl" alt="">
            <div class="tip">微信扫一扫参与问卷调查</div>
        </div>
    </el-dialog>
    <!-- <div class="fixed-box">
        <div class="box icon-quesnaire" v-if="courseDetailsData.iscommonform" @click="openCommonFormDialog"></div>
        <div class="box icon_gotop" @click="gotoTop"></div>
    </div> -->
    <FormDialog @fillInOver="fillInOver" ref="formDialog" />
</div>
</template>

<script>
import {getCourseDetail, getRecommendCourseByDetail, uploadCourseFavorite, getAllCourseNotes, getCourseComment, getCourseTask, uploadCourseJoinInfo, uploadCourseComment, download, getReceiveCouponVoucher} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
import QRCode  from "qrcodejs2"
import FormDialog from '../components/formDialog'
import {getCourseDoc} from 'api/course'
import {urlToQRCode} from 'common/js/tools'
// import '../../../common/js/debugger.js'
export default {
    name: 'CourseDetails',
    data() {
        return {
            isSuccess: true,
            menuIndex: 1, // 机构导航： 1、课程介绍  2、章节目录  3、用户评论  4、课程笔记
            // rateValue: 5, // 评分
            evaRadioValue: 0,
            courseDetailsData: {
                hostinfo: {
                    hostcourselist: []
                },
              iscommonform: 0
            },
            chapterData: [], // 课程章节目录
            courseCommentData: [], // 课程评论
            commentPageTotal: 0, // 课程全部页码
            courseNotesData: [], // 课程全部笔记
            notesPageTotal: 0, // 课程全部页码
            recommendCourse: [], // 底部推荐课程
            joinStudyPop: false, // 加入学习弹窗
            evaCoursePop: false, // 加入学习弹窗
            courseEvaValue: 5, // 评价 ⭐ 分数
            textarea: '', // 评价内容
            showServiceQrImg: false,
            material: [],
            dialogVisible: false,
            getCouponDialog: false,
            getCouponFailDialog: false,
            astrictcount: 0,
            timer: {
              timer: null,
              day: 0,
              hour: 0,
              minute: 0,
              second: 0
            },
            showCommonForm: false, // 问卷二维码
            fillInForm: false,
            fillInArr: []
        }
    },
    created() {
        // console.log('this.domainInfo.isMobile',this.domainInfo)
        if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'MCourseView',
                query: {'cid': this.$route.query.cid, chid: this.$route.query.chid ? this.$route.query.chid : ''}
            })
        }
    },
    mounted() {
        this.findCourseDetail()
        this.findRecommendCourseByDetail()
        this.qRCode()
        this.qRCode2()
    },
    methods: {
        handleGoQbDetails(item) {
            this.$router.push({
                name: 'QuestionDetails',
                query: {
                    qid: item.qbid,
                    courseid: this.$route.query.cid
                }
            })
        },
        gotoTop() {
            $('html').scrollTop(0)
        },
        openCommonFormDialog() {
            this.showCommonForm = true
        },
        fillInOver(arr) {
            this.fillInArr = arr
            this.fillInForm = true
            this.uploadCourseJoinInfo()
            console.log(arr)
        },
        download(item) {
            this.setLoading(true)
            download({
                data: {innerid: item.innerid},
                name: item.orgfilename,
                success: res => {
                    console.log(res)
                    this.setLoading(false)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
            console.log(item)
        },
        getCourseDoc() {
            this.setLoading(true)
            getCourseDoc({
                data: {courseid: this.$route.query.cid, ispage: 0, page: 0, pagesize: 0},
                success: res => {
                    this.setLoading(false)
                    this.material = res.data.content
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        // 页面跳转
        toIndex() {
            this.$router.push({name: 'Index'})
        },
        pageJump(code, titleText) {
            this.$router.push({name: 'Search', query: {typeData: code, title: titleText}})
        },
        qRCode() { // 分享二维码生成
            // console.log(window.location.origin+'/m/courseView?cid='+this.$route.query.cid)
            new QRCode('qrcode', {
                width: 100,
                height: 100, // 高度
                text: window.location.origin+'/m/courseView?cid='+this.$route.query.cid + '&chid=' + (this.$route.query.chid ? this.$route.query.chid : ''),   // 二维码内容
            })
        },
        qRCode2() { // 手机学习二维码生成
            // console.log(window.location.origin+'/m/courseView?cid='+this.$route.query.cid)
            new QRCode('qrcode2', {
                width: 100,
                height: 100, // 高度
                text: window.location.origin+'/m/courseView?cid='+this.$route.query.cid + '&chid=' + (this.$route.query.chid ? this.$route.query.chid : ''),   // 二维码内容
            })
        },
        // 导航点击
        menuClick(val) {
           this.menuIndex = val
           if (val === 2 && this.chapterData.length === 0) {
                this.findCourseTask()
            }
            if (val === 3 && this.courseCommentData.length === 0) {
                this.findCourseComment(1)
            }
            if (val === 4 && this.courseNotesData.length === 0) {
                this.findAllCourseNotes(1)
            }
        },
        // 获取课程详情（含机构信息）
        findCourseDetail() {
            // this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid,
                channelid: this.$route.query.chid ? this.$route.query.chid : ''
            }
            getCourseDetail({
                data: Object.assign({}, params),
                success: data => {
                    // this.setLoading(false)
                    // console.log(data.data)
                  if (data.data.comonformshareurl) data.data.naireUrl = urlToQRCode(data.data.comonformshareurl)
                    this.courseDetailsData = data.data
                console.log(this.courseDetailsData)
                    if (this.courseDetailsData.islimitcount && this.courseDetailsData.endtime) {
                        let endtime = new Date(this.courseDetailsData.endtime).getTime()
                        if (this.timer.timer) clearInterval(this.timer.timer)
                        this.timer.timer = setInterval(() => {
                            this._initTimer(endtime)
                        }, 1000)
                    }
                    this.isSuccess = false
                    this.courseDetailsData.evaluatecount = parseInt(this.courseDetailsData.evaluatecount)
                    document.title=this.courseDetailsData.subject
                    if (this.courseDetailsData.ishavedoc) {
                        this.getCourseDoc()
                    }
                },
                error: data => {
                    // console.log('error：', data)
                    // this.setLoading(false)
                    this.isSuccess = true
                    this.$message.error(data.msg)
                }
            })
        },
        _initTimer(endtime) {
            let current = new Date().getTime()
            let time = (endtime - current ) / 1000
            this.timer.day = parseInt(time / 3600 / 24)
            this.timer.hour = parseInt(time / 3600) % 24 < 10 ? '0' + parseInt(time / 3600) % 24 : parseInt(time / 3600) % 24
            this.timer.minute = parseInt(time /60) % 60 < 10 ? '0' + parseInt(time /60) % 60 : parseInt(time /60) % 60
            this.timer.second = parseInt(time % 60) < 10 ? '0' + parseInt(time % 60) : parseInt(time % 60)
        },
        // 去会员详情页面 zjmemtype: 1为PLUS卡 2为年卡
        handleGoMemberDetails(zjmemtype) {
            console.log(zjmemtype)
            this.$router.push({name: 'MemberDetails', query: {chid: this.$route.query.chid ? this.$route.query.chid : ''}})
        },
        // 立即购买
        buyNow() {
            if (this.user.isLogin) {
                if (this.courseDetailsData.isbuyexpire) {
                    this.dialogVisible = true
                } else {
                    // this.$router.push({name: 'OrderIndex', query: {'cid': this.$route.query.cid}})
                    this.$router.push({name: 'OrderIndex', query: {'kmcinnerid': this.$route.query.cid,'kmctype':7, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                }
            } else {
                this.setLoginPop(true)
            }
        },
        // 确定参与
        affirmJoin() {
            this.dialogVisible = false
            if (this.courseDetailsData.feetype === 1) {
                this.uploadCourseJoinInfo()
            } else {
                // this.$router.push({name: 'OrderIndex', query: {'cid': this.$route.query.cid}})
                this.$router.push({name: 'OrderIndex', query: {'kmcinnerid': this.$route.query.cid,'kmctype':7, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
            }
        },
        // 马上学习
        soonLearn() {
            this.$router.push({name: 'Study', query: {'courseid': this.$route.query.cid}})
        },
        // 提交参与课程（免费课程有效）
        joinCourse() {
            if (this.courseDetailsData.isbuyexpire) {
                this.dialogVisible = true
            } else {
                this.uploadCourseJoinInfo()
            }
        },
        openFormDialog() {
            this.$refs.formDialog.open(this.courseDetailsData.formlist)
        },
        uploadCourseJoinInfo() {
            if (this.user.isLogin) {
                if (this.courseDetailsData.isform && !this.fillInForm) {
                    this.openFormDialog()
                } else {
                    this.setLoading(true)
                    var params = {
                        courseid: this.$route.query.cid,
                        userformlist: JSON.stringify(this.fillInArr),
                        channelid: this.$route.query.chid ? this.$route.query.chid : ''
                    }
                    uploadCourseJoinInfo({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false)
                            console.log(data.data)
                            // if() {},
                            // this.joinStudyPop = true
                            this.soonLearn()
                        },
                        error: data => {
                            // console.log('error：', data)
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                }
            } else {
                this.setLoginPop(true)
            }
        },
        // 关闭参与成功弹窗
        closeJoinStudyPop() {
            this.joinStudyPop = false
            this.courseDetailsData.isjoin = 1
        },
        // 章节任务点击跳转到课程学习页面
        taskClick(val1, val2) {
            console.log(val1)
            console.log(val2)
            this.$router.push({name: 'Study', query: {'courseid': this.$route.query.cid, 'taskid': val2.innerid, 'sectionindexname': val1.sectionindexname, 'taskindexname': val2.taskindexname}})
        },
        // 收藏课程
        enshrineClick(val) {
            this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid,
                optype: val === 1 ? 2 : 1,
                kmctype: 7
            }
            uploadCourseFavorite({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    if(data.code === '000') {
                        if(val === 1) {
                            this.courseDetailsData.isfavorite = 0
                            this.$message.success('已取消收藏')
                        } else {
                            this.courseDetailsData.isfavorite = 1
                            this.$message.success('收藏成功')
                        }
                    }
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
            
        },
        // 获取用户评价接口（详情页）
        findCourseComment(val) {
            this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid,
                page: val,
                pageSize: 10,
                conmenttype: this.evaRadioValue
            }
            if(this.evaRadioValue === 0) {
                params.conmenttype = ''
            }
            getCourseComment({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.courseCommentData = data.data.conmentinfo
                    this.commentPageTotal = data.data.pageinfo.rowCount
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取课程目录（系列课，通用）
        findCourseTask() {
            this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid
            }
            getCourseTask({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.chapterData = data.data.content
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取全部笔记（公开的）
        findAllCourseNotes(val) {
            this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid,
                page: val,
                pagesize: 6
            }
            getAllCourseNotes({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.courseNotesData = data.data.notesinfo
                    this.notesPageTotal = data.data.pageinfo.rowCount
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取推荐课程（课程详情）
        findRecommendCourseByDetail() {
            this.setLoading(true)
            var params = {}
            getRecommendCourseByDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.recommendCourse = data.data.content
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 课程点击
        courseClick(id) {
            // console.log('课程id：', id)
            this.$router.push({name: 'CourseDetails', query: {'cid': id, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
        },
        // 筛选用户评价
        evaFilHandle() {
            // console.log(this.evaRadioValue)
            this.findCourseComment(1)
        },
        // 课程笔记分页
        nfPage(){
            let clickPage = $(".notes_page_box .el-pagination .active").html()
            // this.$message.success(`课程笔记第${clickPage}页`)
            this.findAllCourseNotes(clickPage)
        },
        // 评论分页
        pfPage(){
            let clickPage = $(".evaluate_page_box .el-pagination .active").html()
            // this.$message.success(`评论第${clickPage}页`)
            this.findCourseComment(clickPage)
        },
        // 跳转到机构页面
        toOrganPage(organId, val) {
            // console.log(organId)
            // console.log(val)
            if (val === '课程') {
                this.$router.push({name: 'OrganIndex', query: {'hostid': organId, 'tabs': '2', chid: this.$route.query.chid ? this.$route.query.chid : ''}})
            } else {
                this.$router.push({name: 'OrganIndex', query: {'hostid': organId, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
            }
        },
        // 章节任务时间转行
        secondsFormat(s) { 
            var day = Math.floor( s/ (24*3600) ) // Math.floor()向下取整
            var hour = Math.floor( (s - day*24*3600) / 3600)
            var minute = Math.floor( (s - day*24*3600 - hour*3600) /60 )
            var second = s - day*24*3600 - hour*3600 - minute*60
            // return day + "天"  + hour + "时" + minute + "分" + second + "秒";
            if(s === 0) {
                return ''
            } else {
                if (minute<10) {
                    return '0' + minute + ':' + second
                }else{
                    return minute + ':' + second
                }
            }
        },
        openEvaPop() {
            this.evaCoursePop = true
            // this.courseEvaValue = 5
            // this.textarea = ''
        },
        // 立即评价
        evaBtn() {
            // console.log(this.courseEvaValue)
            if(this.textarea === '') {
                this.$message.error('评论内容不能为空！')
            } else {
                this.setLoading(true)
                var params = {
                    courseid: this.$route.query.cid,
                    content: this.textarea,
                    evaluatecount: this.courseEvaValue
                }
                uploadCourseComment({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        console.log(data.data)
                        this.evaCoursePop = false
                        this.$message.success('评价成功！')
                        this.commentPageTotal = 0
                        this.findCourseComment(1)
                    },
                    error: data => {
                        // console.log('error：', data)
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }
        },
        // 回到顶部
        goTop() {
            // $('#coursedetailswarp').animate({scrollTop:'0'},500)
            $("html,body").animate({
                scrollTop: 0
            }, 400)
        },
        // 领取优惠券
        getCoupon(item, index) {
            console.log(item, index)
            if (this.user.isLogin) {
                if (item.inventory && (item.couponcount < item.countbyper || item.countbyper === 0)) {
                    this.setLoading(true)
                    getReceiveCouponVoucher({
                        data: {couponinnerid: item.couponvoucherid},
                        success: res => {
                            this.setLoading(false)
                            this.getCouponDialog = true
                            ++item.couponcount
                            item.inventory = res.data.inventory
                        },
                        error: res => {
                            this.setLoading(false)
                            this.$message.error(res.msg)
                        }
                    })
                } else if (item.couponcount >= item.countbyper && item.countbyper !== 0) {
                    this.astrictcount = item.countbyper
                    this.getCouponFailDialog = true
                }
            } else {
                this.setLoginPop(true)
            }
        },
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser',
            'setChannelid'
        ])
    },
    filters: {
        ChangeHourMinutestr(str) { // 转分钟
            if (str !== "0" && str !== "" && str !== null) {
                return ((Math.floor(str / 60)).toString().length < 2 ? "0" + (Math.floor(str / 60)).toString() : 
                    (Math.floor(str / 60)).toString()) + ":" + ((str % 60).toString().length < 2 ? "0" + (str % 60).toString() : (str % 60).toString());
            } else {
                return "";
            }
        }
    },
    watch: {
        $route: function(newVal, oldVal) {
            // console.log(oldVal); //oldVa 上一次url
            // console.log(newVal); //newVal 这一次的url
            if (newVal != oldVal) {
                // location.reload()
                this.menuIndex = 1
                this.evaRadioValue = 0
                this.courseDetailsData = {
                    hostinfo: {
                        hostcourselist: []
                    }
                }
                this.chapterData = []
                this.courseCommentData = []
                this.courseNotesData = []
                this.recommendCourse = []
                this.commentPageTotal = 0
                this.notesPageTotal = 0
                this.findCourseDetail()
                this.findRecommendCourseByDetail()
                this.goTop()
            }
        },
        user: function(newVal, oldVal) {
            if (newVal != oldVal) {
                // location.reload()
                this.menuIndex = 1
                this.evaRadioValue = 0
                this.courseDetailsData = {
                    hostinfo: {
                        hostcourselist: []
                    }
                }
                this.chapterData = []
                this.courseCommentData = []
                this.courseNotesData = []
                this.recommendCourse = []
                this.commentPageTotal = 0
                this.notesPageTotal = 0
                this.findCourseDetail()
                this.findRecommendCourseByDetail()
                // if() {}
                this.goTop()
            }
        }
    },
    computed: {
        ...mapGetters(['loginPop', 'user', 'domainInfo', 'channelid'])
    },
    beforeRouteLeave(to, from , next) {
        clearInterval(this.timer.timer)
        next()
    },
    components: {
        FormDialog
    }
}
</script>

<style lang="scss" type="text/scss">
.CourseDetails {
    // margin-top: 80px;
    padding-bottom: 40px;
    display: flex;
    flex-direction: column;
    color: #333;
    height: 100%;
    background: #F8F8F8FF;
    .course_top_warp {
        // background-color: rgb(235, 235, 235);
        background-color: #fff;
        border-bottom: 2px solid rgba(229,229,229,0.5);
        .course_info_warp {
            padding: 30px 0;
            padding-left: 40px;
            box-sizing: border-box;
            margin: 0 auto;
            width: 1200px;
            align-items: center;
            &>div:nth-of-type(1){
                padding-bottom: 30px;
                display: flex;
                color: #333;
                .jump_text{
                    cursor: pointer;
                }
                .jump_text:hover{
                    color: #409EFF;
                }
                &>span{
                    margin: 0 8px;
                }
            }
            &>div:nth-of-type(2){
                display: flex;
                .left_box {
                    width: 460px;
                    height: 262px;
                    box-shadow:0px 2px 8px 0px rgba(0,0,0,0.2);
                    margin-right: 40px;
                    border-radius:10px;
                    overflow: hidden;
                    &>img {
                        width: 460px;
                        height: 262px;
                    }
                    
                }
                .right_box {
                    // flex: 1;
                    width: 640px;
                    // height: 262px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    &>p {
                        text-align: justify;
                    }
                    .p_title {
                        font-size:20px;
                        line-height:28px;
                        font-weight: bold;
                        margin-bottom: 10px;
                    }
                    .p_desc {
                        line-height:20px;
                        color: #999;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-bottom: 10px;
                    }
                    .p_eva {
                        line-height:17px;
                        font-size: 14px;
                        margin: 15px 0;
                        color: #999;
                        display: flex;
                        align-items: center;
                        // &>span:nth-of-type(0){
                        //     color:#666666;
                        // }
                        &>span:nth-of-type(1){
                            color:#666666;
                            margin-right: 10px;
                            font-size: 12px;
                        }
                    }
                    .memberTips {
                        height: 28px;
                        width: 340px;
                        background: #FFF7DF;
                        border-radius: 2px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 10px;
                        box-sizing: border-box;
                        margin-bottom: 15px;
                        cursor: pointer;
                        .iconTips {
                            display: flex;
                            align-items: center;
                            .memberIcon {
                                width: 14px;
                                height: 14px;
                                margin-right: 5px;
                            }
                            .tips {
                                font-size: 12px;
                                color: #7A6544;
                            }
                        }
                        .arrowIcon {
                            width: 5px;
                            height: 9px;
                        }
                    }
                    .coupon {
                        display: flex;
                        // align-items: center;
                        // margin-bottom: 22px;
                        .name {
                            font-size: 12px;
                            color: #666666;
                            margin-right: 20px;
                            white-space: nowrap;
                            padding-top: 2px;
                        }
                        .list {
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                            .getLabel {
                                padding: 2px 10px;
                                font-size: 12px;
                                color: #FF4747;
                                background: #FFE8E8;
                                margin-bottom: 10px;
                                margin-right: 10px;
                                border: 1px solid #FFE8E8;
                            }
                            .item {
                                padding: 2px 10px;
                                cursor: pointer;
                                font-size: 12px;
                                color: #FF4747;
                                background: #FFE8E8;
                                margin-bottom: 10px;
                                border: 1px solid #FF4747;
                                box-sizing: border-box;
                                &:not(:last-of-type) {
                                    margin-right: 10px;
                                }
                            }
                        }
                    }
                    .p_price {
                        line-height:28px;
                        &>label {
                            color: #FF4747FF;
                            font-size:20px;
                        }
                        &>span:nth-of-type(1){
                            color: #FF4747FF;
                            font-size:20px;
                            margin-right: 10px;
                        }
                        &>span:nth-of-type(2){
                            color: #999;
                            font-size:14px;
                            text-decoration:line-through;
                        }
                        .div_price {
                            display: flex;
                            align-items: center;
                            .saleprice {
                                color: #FF4747FF;
                                font-size:20px;
                            }
                            .plusPriceIcon1 {
                                width: 65px;
                                height: 19px;
                                margin: 0 5px 0 8px;
                                // display: inline-block;
                                // position: relative;
                                // top: 1px;
                            }
                            .plusPriceIcon2 {
                                width: 48px;
                                height: 19px;
                                margin: 0 5px 0 8px;
                            }
                            .plusPrice {
                                font-size: 14px;
                                color: #666666;
                            }
                        }
                    }
                    .el-button {
                        width: 160px;
                        height: 40px;
                        margin-top: 20px;
                        margin-bottom: 20px;
                        background: #FF4747FF;
                        font-size: 16px;
                        padding: 0;
                        &.el-button--openPlus {
                            background: linear-gradient(180deg, #707886 0%, #3D434E 100%);
                            color: #FFE0AF;
                            border: none;
                            &:hover, &:active {
                                background: linear-gradient(180deg, #707886 0%, #3D434E 100%);
                                color: #FFE0AF;
                            }
                        }
                        &.el-button--upgrade {
                            background: linear-gradient(180deg, #6FA0FF 0%, #2A51A3 100%);
                            color: #ffffff;
                            border: none;
                            &:hover, &:active {
                                background: linear-gradient(180deg, #6FA0FF 0%, #2A51A3 100%);
                                color: #ffffff;
                            }
                        }
                    }
                    .el-button:hover{
                        background: rgb(238, 106, 106);
                    }
                    .el-button:active {
                        background: rgb(241, 154, 154);
                    }
                    .el-button+.el-button {
                        margin-left: 20px;
                    }
                    .right_bottom_box {
                        height: 24px;
                        display: flex;
                        align-items: center;
                        font-size:12px;
                        &>span {
                            margin-right: 10px;
                            color: #999;
                            white-space: nowrap;
                        }
                        .cursor_class {
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            &>img{
                                width: 16px;
                                height: 16px;
                                margin-right: 4px;
                            }
                        }
                        .is_enshrine{
                            color: #409EFFFF;
                        }
                        .enshrine:hover {
                            color: #409EFFFF;
                        }
                    }
                }
            }
        }
    }
    .course_content_warp {
        font-family:PingFangSC-Medium,PingFang SC;
        padding-top: 20px;
        background-color: #F8F8F8FF;
        flex: 1;
        .container_box {
            // background-color: red;
            width: 1200px;
            margin: 0 auto;
            .course_details_info_box {
                display: flex;
                justify-content: space-between;
                .course_details_info_left {
                    width: 900px;
                    // height: auto;
                    .content_box {
                        min-height: 236px;
                        background-color: #fff;
                        .course_tabs_box {
                            height: 60px;
                            display: flex;
                            align-items: center;
                            border-bottom: 1px solid rgba(229,229,229,0.5);
                            &>div{
                                position: relative;
                                padding: 10px 0;
                                box-sizing: border-box;
                                cursor: pointer;
                                font-size:16px;
                                font-weight: bold;
                                margin-left: 90px;
                                color: #333;
                                font-weight: bold;
                                position: relative;
                                -moz-user-select:none; /* Firefox私有属性 */
                                -webkit-user-select:none; /* WebKit内核私有属性 */
                                -ms-user-select:none; /* IE私有属性(IE10及以后) */
                                -khtml-user-select:none; /* KHTML内核私有属性 */
                                -o-user-select:none; /* Opera私有属性 */
                                user-select:none; /* CSS3属性 */
                                &>span, &>label {
                                    font-size:10px;
                                    color: #999;
                                    line-height:14px;
                                    position: absolute;
                                    top: -4px;
                                    left: 66px;
                                }
                                &>label {
                                    color: #FFF;
                                    text-align: center;
                                    padding: 2px 5px;
                                    white-space: nowrap;
                                    background-color: #FF4747FF;
                                    border-radius: 10px;
                                    top: -6px;
                                }
                            }
                            &>div:hover{
                                color: #409EFFFF;
                            }
                            &>div:nth-of-type(1){
                                margin-left: 30px;
                            }
                            &>div::before{
                                content: '';
                                width: 1px;
                                height: 20px;
                                background-color: rgba(229,229,229,1);
                                position: absolute;
                                bottom: 6px;
                                right: -46px;
                            }
                            &>div:nth-last-of-type(1)::before{
                                width: 0;
                                height: 0;
                            }
                            .active {
                                color: #409EFFFF;
                            }
                            .active::after {
                                content: '';
                                width: 24px;
                                height: 3px;
                                background-color: #409EFF;
                                position: absolute;
                                bottom: -4px;
                                left: 20px;
                            }
                            .menuIndex5 {
                                &.active::after {
                                    left: 4px;
                                }
                            }
                        }
                        .course_tabs_item_box {
                            padding: 30px;
                            font-size: 14px;
                            .no_data_box {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                &>img{
                                    width: 130px;
                                    height: 76px;
                                    margin-bottom: 20px;
                                }
                                &>span{
                                    color: #CADAEEFF;
                                    line-height:20px;
                                }
                            }
                            .page_box {
                                display: flex;
                                justify-content: center;
                                padding-bottom: 10px;
                            }
                        }
                        .introduce_warp{
                            padding: 20px;
                            .no_data_box {
                                padding: 10px;
                            }
                            .introduce_box {
                                * {
                                    font-size: 14px;
                                    color: #999;
                                    line-height: 20px;
                                    max-width: 100%;
                                }
                                img {
                                    max-width: 100%;
                                    position: relative;
                                    // line-height: 0;
                                    vertical-align: middle;
                                }
                            }
                        }
                        .cata_warp{
                            .cata_box{
                                .cata_item_box {
                                    margin-bottom: 20px;
                                    .cata_title_text {
                                        font-size:14px;
                                        line-height:20px;
                                        color:rgba(51,51,51,1);
                                        margin-bottom: 20px;
                                        display: flex;
                                        justify-content: space-between;
                                        &>span:nth-of-type(1){
                                            font-weight:bold;
                                        }
                                        &>span:nth-of-type(2){
                                            color: #999;
                                        }
                                    }
                                    .no_task_box {
                                        height: 40px;
                                        line-height: 40px;
                                        color: #999;
                                        padding: 0 20px;
                                    }
                                    .section_box {
                                        padding: 0 12px;
                                        height: 40px;
                                        margin-bottom: 6px;
                                        display: flex;
                                        justify-content: space-between;
                                        align-items: center;
                                        background:rgba(248,248,248,1);
                                        &>div:nth-of-type(1){
                                            display: flex;
                                            &>p:nth-of-type(1){
                                                width: 0px;
                                                // width: 53px;
                                                color: #999;
                                            }
                                            &>p:nth-of-type(2){
                                                width: 650px;
                                                white-space: nowrap;
                                                text-overflow: ellipsis;
                                                overflow: hidden;
                                                word-break: break-all;
                                            }
                                        }
                                        &>div:nth-of-type(2){
                                            display: flex;
                                            .isTry {
                                                color: #409EFF;
                                                margin-right: 12px;
                                            }
                                            .no_hover_box {
                                                display: flex;
                                                &>img {
                                                    width: 14px;
                                                    height: 14px;
                                                    margin-right: 10px
                                                }
                                                &>p{
                                                    width: 32px;
                                                    color: #999;
                                                }
                                            }
                                            .hover_box {
                                                display: none;
                                                color: #409EFF;
                                                &>div {
                                                    display: flex;
                                                    &>img {
                                                        width: 14px;
                                                        height: 14px;
                                                        margin-right: 6px
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    .section_box:nth-last-of-type(1) {
                                        margin-bottom:0;
                                    }
                                    .section_box:hover{
                                        cursor: pointer;
                                        background:rgba(241,248,255,1);
                                        &>div:nth-of-type(2){
                                            .no_hover_box {
                                                display: none;
                                            }
                                            .hover_box {
                                                display: flex;
                                            }
                                            .isTry {
                                                display: none;
                                            }
                                        }
                                    }
                                }
                                .cata_item_box:nth-last-of-type(1) {
                                    margin-bottom:0;
                                }
                            }
                        }
                        .evaluate_warp{
                            padding: 15px 12px 30px 12px;
                            .no_data_box {
                                padding: 15px 18px 0 18px;
                            }
                            .evaluate_btn_box {
                                background-color: #FFF7EC;
                                height:46px;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                padding: 0 20px;
                            }
                            .evaluate_box{
                                .evaluate_filtrate_box {
                                    background-color: #F8F7F7;
                                    height: 78px;
                                    box-sizing: border-box;
                                    padding: 0 48px;
                                    // padding-right: 10px;
                                    display: flex;
                                    align-items: center;
                                    margin-top: 12px;
                                    margin-bottom: 20px;
                                    &>div:nth-of-type(1){
                                        &>p{
                                            text-align: center;
                                        }
                                        p:nth-of-type(1){
                                            line-height:37px;
                                            font-size:26px;
                                            color:rgba(64,158,255,1);
                                        }
                                        p:nth-of-type(2){
                                            line-height:20px;
                                            color:rgba(51,51,51,1);
                                        }
                                    }
                                    &>div:nth-of-type(2){
                                        height: 38px;
                                        box-sizing: border-box;
                                        margin: 0 48px;
                                        padding-left: 48px;
                                        padding-top: 12px;
                                        border-left: 1px solid #E5E5E5;
                                        &>div {
                                            display: flex;
                                        }
                                    }
                                    // &>div:nth-of-type(3){
                                    //     background-color: red;
                                    // }
                                    .el-radio {
                                        margin-right: 20px;
                                    }
                                    .el-radio:nth-last-of-type(1) {
                                        margin-right: 0;
                                    }
                                }
                                .margin_top0 {
                                    margin-top: 0;
                                }
                                .evaluate_item_warp {
                                    .evaluate_item_box {
                                        display: flex;
                                        margin-bottom: 20px;
                                        padding: 0 18px;
                                        padding-bottom: 20px;
                                        border-bottom: 1px solid #F5F5F5;
                                        &>img {
                                            width: 46px;
                                            height: 46px;
                                            margin-right: 24px;
                                            border-radius: 50%;
                                        }
                                        &>div {
                                            // width: 770px;
                                            flex: 1;
                                            .name_div {
                                                height: 46px;
                                                display: flex;
                                                flex-direction: column;
                                                justify-content: space-between;
                                                &>span {
                                                    font-weight: bold;
                                                    line-height:20px;
                                                }
                                            }
                                            .details_text {
                                                line-height:22px;
                                                margin-top: 10px;
                                                margin-bottom: 12px;
                                            }
                                            .date_text {
                                                color: #999;
                                                line-height:20px;
                                            }
                                        }
                                    }
                                    .evaluate_item_box:nth-last-of-type(1){
                                        border-bottom: none;
                                        margin-bottom: 10px;
                                    }
                                }
                            }
                        }
                        .notes_warp {
                            .notes_box {
                                .notes_item_box {
                                    display: flex;
                                    margin-bottom: 20px;
                                    padding-bottom: 20px;
                                    border-bottom: 1px solid #F5F5F5;
                                    &>img {
                                        width: 46px;
                                        height: 46px;
                                        margin-right: 24px;
                                        border-radius: 50%;
                                    }
                                    &>div {
                                        // width: 560px;
                                        flex: 1;
                                        .name_text {
                                            line-height: 46px;
                                            font-weight: bold;
                                        }
                                        .details_text {
                                            line-height:22px;
                                            margin-top: 8px;
                                            margin-bottom: 12px;
                                        }
                                        &>div {
                                            line-height:20px;
                                            display: flex;
                                            justify-content: space-between;
                                            color: #999;
                                            // &>p:nth-of-type(1){
                                            // }
                                            &>p:nth-of-type(2){
                                                display: flex;
                                                align-items: center;
                                                &>img {
                                                    cursor: pointer;
                                                    width: 16px;
                                                    height: 16px;
                                                    margin-right: 6px;
                                                }
                                            }
                                        }
                                    }
                                }
                                .notes_item_box:nth-last-of-type(1){
                                    border-bottom: none;
                                    margin-bottom: 10px;
                                }
                            }
                        }
                        .data_warp {
                            .material_item {
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                background: #F8F8F8;
                                margin-bottom: 6px;
                                height: 40px;
                                padding: 0 20px;
                                font-size: 14px;
                                .material_item_btn {
                                    color: #409EFF;
                                    display: none;
                                    .box {
                                        cursor: pointer;
                                        display: flex;
                                        align-items: center;
                                        img {
                                            // padding-top: 20px;
                                            width: 18px;
                                            height: 18px;
                                            margin-right: 6px;
                                            display: inline-block;
                                        }
                                    }
                                }
                                &:hover {
                                    background: #F1F8FF;
                                    .material_item_btn {
                                        display: block;
                                    }
                                }
                            }
                        }
                        .ques_warp {
                            .quesItem {
                                display: flex;
                                align-items: center;
                                padding: 10px 20px;
                                background: #F8F8F8;
                                margin-bottom: 6px;
                                cursor: pointer;
                                .quesName {
                                    flex: auto;
                                    width: 0;
                                    font-size: 14px;
                                    color: #333333;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    line-height: 18px;
                                    transition: all 0.3s;
                                }
                                .rightHandle {
                                    .isJoin {
                                        display: none;
                                        align-items: center;
                                        margin-left: 80px;
                                        font-size: 14px;
                                        color: #409EFF;
                                        transition: all 0.3s;
                                        .icon {
                                            width: 18px;
                                            height: 18px;
                                            margin-right: 6px;
                                        }
                                    }
                                    .noJoin {
                                        display: none;
                                        font-size: 14px;
                                        color: #FFB261;
                                        margin-left: 80px;
                                        transition: all 0.3s;
                                    }
                                }
                                &:hover {
                                    background: #F1F8FF;
                                    .rightHandle {
                                        .isJoin {
                                            display: flex;
                                        }
                                        .noJoin {
                                            display: block;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .course_details_info_right {
                    width: 280px;
                    min-height: 236px;
                    .organ_info_box1 {
                        margin-bottom: 12px;
                        // min-height: 160px;
                        background-color: #fff;
                        padding: 16px;
                        .box1 {
                            display: flex;
                            padding-bottom: 15px;
                            border-bottom: 1px solid #F5F5F5;
                            &>img {
                                width: 60px;
                                height: 60px;
                                margin-right: 10px;
                                cursor: pointer;
                            }
                            &>div {
                                &>p {
                                    line-height:22px;
                                    font-size: 16px;
                                    color: #409EFF;
                                    margin-bottom: 6px;
                                    cursor: pointer;
                                }
                                &>img {
                                    width: 75px;
                                    height: 26px;
                                }
                            }
                        }
                        .box2 {
                            display: flex;
                            align-items: center;
                            padding: 16px 0;
                            &>div{
                                cursor: pointer;
                                display: flex;
                                flex: 1;
                                flex-direction: column;
                                justify-content: center;
                                &>p{
                                    line-height:17px;
                                    color: #666;
                                    font-size:12px;
                                    margin-bottom: 4px;
                                    text-align: center;
                                }
                                &>span{
                                    color: #409EFF;
                                    font-size:14px;
                                    line-height:20px;
                                    text-align: center;
                                }
                            }
                            &>label{
                                // padding: 0 1px;
                                width: 1px;
                                height: 21px;
                                background-color: #E5E5E5;
                                // background-color: rgb(253, 0, 0)
                            }
                        }
                        .box3 {
                            color: #666;
                            font-size:12px;
                            line-height:17px;
                            padding-top: 15px;
                        }
                    }
                    .organ_info_box2 {
                        background-color: #fff;
                        // min-height: 100px;
                        padding: 16px;
                        margin-bottom: 12px;
                        display: flex;
                        position: relative;
                        cursor: pointer;
                        &>img{
                            width: 80px;
                            height: 80px;
                            margin-right: 15px;
                        }
                        &>div{
                            height: 80px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            &>P:nth-of-type(1){
                                font-size: 16px;
                                line-height:20px;
                                color: #333;
                                margin-bottom: 10px;
                            }
                            &>P:nth-of-type(2){
                                line-height:17px;
                                font-size: 12px;
                                color: #999;
                            }
                        }
                    }
                    .organ_info_box3 {
                        padding: 16px;
                        background-color: #fff;
                        min-height: 300px;
                        .tdkc {
                            line-height:20px;
                        }
                        .kc_box {
                            margin-top: 10px;
                            padding-bottom: 10px;
                            border-bottom: 1px solid #F5F5F5;
                            overflow: hidden;
                            border-radius:4px;
                            cursor: pointer;
                            &>img{
                                border-radius:4px;
                                width: 248px;
                                height: 140px;
                                margin-bottom: 10px;
                            }
                            &>p{
                                line-height:20px;
                                text-align: justify;
                                padding: 0 4px;
                                text-overflow: -o-ellipsis-lastline;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                        }
                        .kc_box:nth-last-of-type(1) {
                            border-bottom: none;
                        }
                        .kc_box:hover {
                            transition: all .3s;
                            -moz-transition: all .3s;
                            -o-transition: all .3s;
                            -ms-transition: all .3s;
                            -webkit-transition: all .3s;
                            box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                            -moz-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                            -o-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                            -ms-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                            -webkit-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        }
                    }
                }
            }
            .recommend_title_text {
                padding: 0 10px;
                margin: 30px 0;
                font-size:20px;
                line-height:28px;
                // font-weight: bold;
                color: #666;
            }
            .recommend_course_box{
                padding: 0 10px;
                min-height: 200px;
                display: flex;
                flex-wrap: wrap;
                .course_item_div {
                    margin-right: 12px;
                    margin-bottom: 20px;
                    cursor: pointer;
                    width: 226px;
                    border-radius:4px;
                    display: flex;
                    flex-direction: column;
                    &>img{
                        width: 226px;
                        height: 118px;
                        border-radius:4px;
                        margin-bottom: 10px;
                    }
                    &>div{
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        &>p {
                            text-align: justify;
                            padding: 0 4px;
                            font-size:16px;
                            line-height:20px;
                            // font-weight: bold;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                        &>p:nth-of-type(2) {
                            padding: 10px 4px;
                            font-weight: normal;
                            color: #999;
                            font-size:12px;
                            &>span {
                                font-size:14px;
                                color: #FF4747FF;
                                margin-right: 10px;
                            }
                        }
                    }
                }
                .course_item_div:nth-of-type(5n){
                    margin-right: 0;
                }
                .course_item_div:hover{
                    transition: all .3s;
                    -moz-transition: all .3s;
                    -o-transition: all .3s;
                    -ms-transition: all .3s;
                    -webkit-transition: all .3s;
                    box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                    -moz-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                    -o-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                    -ms-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                    -webkit-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                }
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.4s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        transition: opacity 0.4s;
        opacity: 0
    }
    .join_study_pop, .eva_course_pop, .qr_img_pop {
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background:rgba(0,0,0,0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2000;
        &>div {
            position: relative;
            border-radius:4px;
            background:rgba(255,255,255,1);
            .close_icon {
                cursor: pointer;
                position: absolute;
                right: 11px;
                top: 10px;
                width: 12px!important;
                height: 12px!important;
            }
        }
        .join_study_box {
            width:375px;
            height:218px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &>img {
                width: 51px;
                height: 54px;
            }
            &>p {
                font-size:16px;
                line-height:22px;
                margin-top: 19px;
                margin-bottom: 26px;
            }
            .el-button--mini, .el-button--small {
                font-size: 16px;
                width: 162px;
            }
            
        }
        .eva_course_box {
            width:456px;
            // height: 270px;
            padding: 24px 30px;
            &>P{
                line-height:20px;
            }
            &>p:nth-of-type(1){
                font-size:14px;
            }
            &>p:nth-of-type(2){
                margin-top: 15px;
                margin-bottom: 20px;
                font-size:12px;
                display: flex;
                align-items: center;
            }
            .el-textarea__inner {
                height: 90px;
                max-height: 90px;
            }
            &>div {
                margin-top: 27px;
                display: flex;
                justify-content: center;
                .el-button--mini, .el-button--small {
                    font-size: 14px;
                    width: 100px;
                }
            }
        }
    }
    .qr_img_pop {
        &>div {
            &>img {
                width: 210px;
                height: 210px;
            }
            padding: 32px;
        }
    }
    .limit-time{
        width: 560px;
        margin-bottom: 10px;
        .limit-time-header{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 16px;
            height: 36px;
            background: linear-gradient(24deg, #FF4952 0%, #FF8047 100%);
            color: #fff;
            font-size: 14px;
            .left{
                flex-grow: 1;
                display: flex;
                align-items: center;
                .icon:before{
                    width: 16px;
                    height: 17px;
                    margin-right: 10px;
                }
            }
            .right{
                display: flex;
                align-items: center;
                .time-box{
                    width: 20px;
                    min-width: 20px;
                    height: 20px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    color: #EC5E69;
                    font-size: 12px;
                    text-align: center;
                    line-height: 20px;
                }
                .sepa-l{
                    margin-left: 4px;
                }
                .sepa-r{
                    margin-right: 4px;
                }
            }
        }
        .limit-time-body{
            display: flex;
            align-items: center;
            height: 48px;
            padding: 0 16px;
            .label{
                color: #999999;
                font-size: 12px;
            }
            .saleprice{
                color: #FF4747;
                font-size: 20px;
                margin: 0 10px;
            }
            .uprice{
                color: #999999;
                font-size: 14px;
                text-decoration: line-through;
            }
        }
        .limit-time-footer{
            padding: 0 16px 16px 16px;
            .el-button{
                margin: 0 !important;
            }
        }
    }
    .fixed-box{
        position: fixed;
        bottom: 150px;
        right: 30px;
        z-index: 10;
        .box{
            background: #FFFFFF;
            box-shadow: 0 0 4px 0 rgba(0,0,0,0.10);
            border-radius: 4px;
            overflow: hidden;
            &:before{
                display: block;
                width: 45px;
                height: 45px;
            }
        }
        .box+.box{
            margin-top: 8px;
        }
    }
}
.icon_popover_box {
    #qrcode, #qrcode2{
        margin-bottom: 6px;
    }
}
.page-footer{
    margin-top: 0;
}
.dialog {
    .el-dialog__body {
        .content {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img {
                margin-bottom: 28px;
            }
            p {
                font-size: 16px;
            }
        }
    }
    .dialog-footer {
        width: 100%;
        padding-left: 30px;
        display: flex;
        .el-button {
            width: 120px;
            height: 30px;
            line-height: 30px;
            padding: 0;
            text-align: center;
            border-radius: 14px;
            border: none;
        }
        .cancel {
            background: #E5E5E5;
            color: #666666;
        }
        .affirm {
            background: #FF4747;
            margin-left: 30px;
        }
    }
}
.getCouponDialog {
    .el-dialog {
        margin-top: 25vh !important;
    }
    .el-dialog__body {
        padding: 20px 40px 40px;
        .getCouponDialogContent {
            text-align: center;
            .success {
                width: 44px;
                height: 44px;
                margin: auto;
                margin-bottom: 14px;
            }
            .success_tips {
                font-size: 16px;
                margin-bottom: 4px;
                line-height: 22px;
            }
            .tips {
                font-size: 14px;
                color: #999999;
                margin-bottom: 30px;
                line-height: 20px;
            }
            .el-button {
                width: 100px;
                height: 30px;
                background: #409EFF;
                line-height: 30px;
                color: #fff;
                padding: 0;
            }
        }
    }
}
.getCouponFailDialog {
    .el-dialog__body {
        padding: 10px 20px 30px;
    }
    .getCouponFailDialogContent {
        text-align: center;
        .fail_tips {
            font-size: 16px;
            color: #EC5E69;
            line-height: 22px;
            margin-bottom: 4px;
        }
        .tips {
            font-size: 14px;
            color: #999999;
            line-height: 20px;
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
            height: 30px;
            background: #409EFF;
            line-height: 30px;
            color: #fff;
            padding: 0;
        }
    }
}
.commonform{
    .el-dialog__body{
        padding-top: 10px;
    }
    .container{
        color: #333;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .img{
            width: 140px;
            height: 140px;
            margin-bottom: 10px;
        }
    }
}
</style>